import axios from 'axios';
import config from '../config';
import {JsonHeaders} from '../constants';

export default {
    getRelay(id) {
        return axios.get(config.publicPath + 'smtp_relays/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    getRelays(currentPage, perPage, orderField, orderDirection, account, user_id, group_id, smtp_id) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            account: account,
            "user.id": user_id,
            "group.id": group_id,
            "smtpServer.id": smtp_id
        };
        parameters['order[' + orderField +']'] = orderDirection;
        return axios.get(config.publicPath + 'smtp_relays', {
            params: parameters,
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    createRelay(formData) {
        return axios.post(config.publicPath + 'smtp_relays', formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    updateRelay(id, formData) {
        return axios.put(config.publicPath + 'smtp_relays/' + id, formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    deleteRelay(id) {
        return axios.delete(config.publicPath + 'smtp_relays/' + id, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    uploadRelays(data) {
        return axios.post(config.publicPath + 'upload_smtp_relays', data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    bulkMove(relays, group) {
        let data = {relaysIds: relays, groupId: group};
        return axios.post(config.publicPath + 'smtp_relays/bulk_move', JSON.stringify(data), {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    bulkActivity(relays, activity) {
        let data = {relaysIds: relays, activity: activity};
        return axios.post(config.publicPath + 'smtp_relays/bulk_activity', JSON.stringify(data), {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    bulkDelete(relays) {
        let data = {relaysIds: relays};
        return axios.post(config.publicPath + 'smtp_relays/bulk_delete', JSON.stringify(data), {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    }
}